import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCcHM8QPAIBKh83LYtni0KnSFwgd2Llbsc",
  authDomain: "fortuneteller-f7b86.firebaseapp.com",
  projectId: "fortuneteller-f7b86",
  storageBucket: "fortuneteller-f7b86.firebasestorage.app",
  messagingSenderId: "101341862670",
  appId: "1:101341862670:web:98d3d639c7549a4b5a555f",
  measurementId: "G-Q2GB010886"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
